{
  "name": "@shoc/shoc",
  "version": "1.0.3",
  "type": "module",
  "description": "Run your jobs on Shoc Platform via Shoc CLI.",
  "publishConfig": {
    "access": "public"
  },
  "license": "ISC",
  "author": {
    "name": "davitp",
    "url": "https://github.com/davitp"
  },
  "bugs": {
    "url": "https://github.com/shoc-dev/cli/issues"
  },
  "homepage": "https://github.com/shoc-dev/cli#readme",
  "files": [
    "dist"
  ],
  "main": "index.tss",
  "exports": "./dist/index.js",
  "bin": {
    "shoc": "./dist/index.js"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "semantic-release": "semantic-release"
  },
  "keywords": [
    "shoc",
    "HPC",
    "ML",
    "AI",
    "MPI",
    "Kubernetes",
    "OpenMPI",
    "TensorFlow",
    "PyTorch"
  ],
  "packageManager": "pnpm@10.9.0",
  "dependencies": {
    "@dotenvx/dotenvx": "^1.45.1",
    "archiver": "^7.0.1",
    "axios": "^1.10.0",
    "chalk": "^5.4.1",
    "commander": "^12.1.0",
    "dayjs": "^1.11.13",
    "figlet": "^1.8.1",
    "formdata-node": "^6.0.3",
    "git-url-parse": "^15.0.0",
    "glob": "^11.0.3",
    "isomorphic-git": "^1.31.0",
    "jose": "^5.10.0",
    "keytar": "^7.9.0",
    "net": "^1.0.2",
    "open": "^10.1.2",
    "ora": "^8.2.0",
    "prompts": "^2.4.2",
    "table": "^6.9.0",
    "undici": "^7.10.0",
    "yaml": "^2.8.0"
  },
  "devDependencies": {
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^11.0.3",
    "@semantic-release/npm": "^12.0.1",
    "@semantic-release/release-notes-generator": "^14.0.3",
    "@types/archiver": "^6.0.3",
    "@types/figlet": "^1.7.0",
    "@types/git-url-parse": "^9.0.3",
    "@types/node": "^22.15.32",
    "@types/prompts": "^2.4.9",
    "semantic-release": "^24.2.5",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "pnpm": {
    "onlyBuiltDependencies": [
      "esbuild",
      "keytar"
    ]
  }
}
